import { ActionTree, Commit } from "vuex";
import { RootState } from "./types";
import CombookBindingCover from "../models/CombookBindingCover";

import Family from "../models/Family";

// TODO: actionが増えてきたので、サブストアに分離すべきか？
export const actions: ActionTree<RootState, RootState> = {
  startLoading(context: { commit: Commit }): any {
    context.commit("setLoading", true);
  },
  endLoading(context: { commit: Commit }): any {
    context.commit("setLoading", false);
  },
  showRequireLoginDialog(context: { commit: Commit }): any {
    context.commit("setLoginRequired", true);
  },
  showRequireRefreshDialog(context: { commit: Commit }): any {
    context.commit("setRefreshRequired", true);
  },
  openErrorDialog(
    context: { commit: Commit },
    payload: { messages: Array<string> }
  ) {
    context.commit("setErrorDialog", {
      dialog: true,
      messages: payload.messages
    });
  },
  closeErrorDialog(context: { commit: Commit }) {
    context.commit("setErrorDialog", { dialog: false, messages: [] });
  },
  clearErrorMessages(context: { commit: Commit }) {
    context.commit("setErrorMessages");
  },
  toggleDrawer(context: { commit: Commit; state: RootState }) {
    context.commit("setDrawer", !context.state.drawer);
  },
  async checkVersion(context: { state: RootState }): Promise<boolean> {
    const requiredVersion = await context.state.apiClient.getVersion();
    if (!requiredVersion) {
      // 何らかの事情でバージョンが取れない。エラーにすると身動きが取れなくなるかもしれないため、スルーする。
      return true;
    } else if (context.state.clientVersion >= requiredVersion) {
      return true;
    } else {
      console.warn(
        `Client must be updated, clientVersion: ${context.state.clientVersion} < requiredVersion: ${requiredVersion}`
      );
      return false;
    }
  },
  async changeFamily(
    context: { commit: Commit; state: RootState },
    payload: { familyId: number }
  ): Promise<Family> {
    const family = await context.state.apiClient.changeFamily(payload.familyId);

    context.commit("family/setFamily", family);
    context.commit("cart/clearCart");
    context.commit("organization/clearOrganization");

    return family;
  },
  async sendActivationEmail(context: { state: RootState }): Promise<void> {
    await context.state.apiClient.sendActivationEmail();
  },
  async activateUser(
    context: { state: RootState },
    payload: { token: string }
  ): Promise<void> {
    await context.state.apiClient.activateUser(payload.token);
  },
  async createCombookBindingCover(
    context: { state: RootState },
    payload: CombookBindingCover
  ): Promise<{ uploadUrl: string; coverId: number }> {
    return await context.state.apiClient.createCombookBindingCover(
      payload.organizationId,
      payload
    );
  },
  async generateCombookBindingCover(
    context: { state: RootState },
    payload: { organizationId: number; coverId: number }
  ): Promise<{ id: number; thumbnailUrl: string }> {
    return await context.state.apiClient.generateCombookBindingCover(
      payload.organizationId,
      payload.coverId
    );
  }
};
